import { useState } from "react";
import ProgramSwitcherDialog from "./ProgramSwitcherDialog.tsx";
import ConfirmProgramOptOutDialog from "./ConfirmProgramOptOutDialog.tsx";

export default function ProgramDialogManager({
  onRequestClose,
}: {
  onRequestClose: () => void;
}) {
  const [activeDialog, setActiveDialog] = useState<
    "switch-program" | "confirm-opt-out"
  >("switch-program");

  if (activeDialog === "switch-program") {
    return (
      <ProgramSwitcherDialog
        onRequestClose={onRequestClose}
        onShowConfirm={() => {
          setActiveDialog("confirm-opt-out");
        }}
      />
    );
  }
  if (activeDialog == "confirm-opt-out") {
    return <ConfirmProgramOptOutDialog onRequestClose={onRequestClose} />;
  }
}
